import Stack from "@mui/material/Stack";
import GoogleLoginView from "./socialMedia/GoogleLoginView";

const SocialMediaLoginView = () => {
    const styles = {
        label: {
            fontWeight: 600,
            mb: .5
        },
    }
    return (
        <Stack spacing={1} direction="row" justifyContent="center" alignItems="center">
            <GoogleLoginView />
        </Stack>
    );
};

export default SocialMediaLoginView;